import React from 'react'
import HelpButton from './buttons/help'
import SettingButton from './buttons/setting'
import AppBar from 'material-ui/AppBar'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import Toolbar from 'material-ui/Toolbar'
import { withStyles } from 'material-ui/styles';

const styles = {
  flex: {
    flex: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
};


const Header = (props) => {
  const classes = props.classes
  return (
    <div className={classes.root}>
      <AppBar position="static" color="primary">
        <Toolbar>
          <Typography variant="title" color="inherit" className={classes.flex}>
            文献引用助手
          </Typography>
          <Button color="inherit" href="/journal" target="_blank">文献解析</Button>
          <Button color="inherit" href="/post-spectra" target="_blank">光谱处理</Button>
          <SettingButton />
          <HelpButton />
        </Toolbar>
      </AppBar>
    </div>
  )
}

export default withStyles(styles)(Header);


// WEBPACK FOOTER //
// ./src/components/header.js